import { useMediaQuery } from "@chakra-ui/react";

import DefaultModal from "@/components/ui/modals/DefaultModal";

import { FiltersBlockModal } from "../../../companiesListComponents/tablesTools/innerComponents/filtersBlock/FiltersBlockModal";

/**
 * Modal component for filtering views
 * @param {Object} props - Component props
 * @param {Object} props.controlModal - Modal control object
 * @param {boolean} props.controlModal.isOpen - Whether the modal is open
 * @param {() => void} props.controlModal.onClose - Function to close the modal
 * @see src/components/ui/modals/DefaultModal.tsx
 * @see src/components/companies/companiesList/companiesListComponents/tablesTools/innerComponents/filtersBlock/FiltersBlockModal.tsx
 */
const ViewFilterModal = ({ 
  controlModal 
}: { 
  controlModal: { 
    isOpen: boolean; 
    onClose: () => void;
  };
}) => {
  const [isTablet] = useMediaQuery("(max-width: 768px)");
  return (
    <>
      {controlModal?.isOpen ? (
        <DefaultModal
          {...{
            isOpen: controlModal?.isOpen,
            onClose: controlModal?.onClose,
            content_style: {
              p: "12px",
              w: { base: "100vw", md: "704px" },
              minW: { base: "100vw", md: "704px" },
              h: { base: "100vh", md: "586px" },
            },
            modalStyle: {
              borderRadius: { base: "0px", md: "10px" },
              mx: { base: "0px", md: "24px" },
              w: { base: "100vw", md: "704px" },
            },
            isCloseBtn: isTablet,
          }}
        >
          <FiltersBlockModal {...{ controlModal }} />
        </DefaultModal>
      ) : null}
    </>
  );
};

export default ViewFilterModal;
